import { useEffect, useRef, useState } from 'react';
import classes from './TextareaBox.module.css'
import { useCanEdit, useUserTabEditPermissionDisabled, useCanEditArchived } from '../../../lib/usersPermissions';


const TextareaBox = ({label, name, required, placeholder, height, currentValue, action, identifier, isNotModifiable, apiDisabled, showApiLoader}) => {
    // let masterDisable = useCanEdit()
    let editArchivedDisabled = useCanEditArchived()
    let userPermissionDisabled = useUserTabEditPermissionDisabled(identifier?.permissionType ? identifier?.permissionType : identifier?.type) 

    const textareaRef = useRef(null);
    const [isfocused, setIsFocused] = useState(false)
    const [preselectedValue, setPreselectedValue] = useState(currentValue)



    const foucsHandler = () => {
        if (!userPermissionDisabled) { // check for user permission first 
            setIsFocused(true)
        }
        
    }

    

    const blurHandler = (e) => {
        if (!userPermissionDisabled) { // check for user permission first 
            if (e.target.value == '') {
                setIsFocused(false)
            }    
            
            if (e.target.value && action && e.target.value !== currentValue) {
                action({
                    data: {
                        value: e.target.value
                    },
                    identifier: identifier
                })
            }
        }
        
    }


    const clearInputHandler = () => {
        if (!userPermissionDisabled) { // check for user permission first
            textareaRef.current.value = "";
            setIsFocused(false)

            if (action) {
                action({
                    data: {
                        value: null
                    },
                    identifier: identifier
                })
            }
        }
        
    }


    useEffect(() => {
        if (currentValue) {
            setIsFocused(true)
        }
    }, [currentValue])

    useEffect(() => {
        if (currentValue) {
            setIsFocused(true)
            // setPreselectedValue(currentValue)
            textareaRef.current.value = currentValue;
        } else {
            // setPreselectedValue(null)
            textareaRef.current.value = "";
        }
    }, [currentValue])

    const isDisabled = Boolean(apiDisabled || isNotModifiable || editArchivedDisabled || userPermissionDisabled)

    return <div className={`${classes.textarea_box} ${height ? classes[`height_${height}`] : ''}`}>
        <div className={`${classes.textarea_box_fields} ${isfocused && classes.focused}`}>
            {label && <label htmlFor={name} className={classes.label}>{label}{required ? <span className={'required'}>*</span> : ''}{showApiLoader && apiDisabled ? <span className="loader dark field_label_loader" /> : null}</label>}
            <textarea ref={textareaRef} className={classes.textarea}  name={name} id={name} required={required} placeholder={placeholder} onFocus={foucsHandler} onBlur={blurHandler} defaultValue={preselectedValue} disabled={isDisabled} />
            <button className={classes.clear_input} type='button' onClick={clearInputHandler} disabled={isDisabled}>
                <i className='ti ti-x'></i>
                <span className='sr-only'>clear input</span>
            </button>
        </div>
    </div>
}

export default TextareaBox